export var DEFAULT_SEO_TYPE = 'LocalBusiness';
export var SUB_CATEGORY_TO_SEO_TYPE = {
  rest: 'FoodEstablishment',
  spa: 'HealthAndBeautyBusiness',
  salon: 'HealthAndBeautyBusiness',
  hair: 'HealthAndBeautyBusiness'
};